 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-069b5a0f":"78d86aa4","chunk-0bed69fb":"f142d8ba","chunk-0e3b4938":"f11d26b7","chunk-19814e2a":"5de7b356","chunk-1ab92bba":"c415d585","chunk-225cb554":"a8e1414d","chunk-2f7cec82":"974fd81c","chunk-61bcfbda":"d80ae016","chunk-7eeb79c0":"35343b64","chunk-85ef4af6":"f01d4eb5","chunk-e2e632f4":"429f8bd0","chunk-1b23f0d2":"d2fee2f0","chunk-2d20f987":"e519a6e4","chunk-2daba2ce":"e135c96c","chunk-2f6e9d50":"135a1258","chunk-302c9c2a":"cb6a5abd","chunk-37e94ac7":"769488fc","chunk-3aed29f0":"24205b47","chunk-4864a9c6":"0b1f7819","chunk-5322f370":"255d884c","chunk-5ec75d54":"ab8c0ede","chunk-64090c9b":"dfa3e32c","chunk-64bc9d04":"d39a6147","chunk-264ea8e3":"b2b25f6a","chunk-580f2e46":"1cbff6ed","chunk-63987aca":"063f97bc","chunk-76bde2a4":"3e9f6dbb","chunk-8aa503b8":"890c0935","chunk-f730c4d0":"30d6322f","chunk-6aa192fa":"caf6ead8","chunk-7163177a":"19e9db7b","chunk-7ed3ff22":"8510ae77","chunk-859f39b0":"ccfa83f3","chunk-97705c9e":"0d544262","chunk-9f9481d0":"83e9db4a","chunk-a87c9a62":"f3a4208b","chunk-bd612336":"7dadf6be","chunk-c70fde1c":"c62eeadf","chunk-d21901a2":"5b14e035","chunk-da49554a":"7827f3fc","chunk-e26ed996":"b45c4125","chunk-f243ee4e":"299fbe9e","chunk-f9e8fb12":"142a8f70"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-069b5a0f":1,"chunk-0e3b4938":1,"chunk-1ab92bba":1,"chunk-225cb554":1,"chunk-61bcfbda":1,"chunk-7eeb79c0":1,"chunk-85ef4af6":1,"chunk-e2e632f4":1,"chunk-1b23f0d2":1,"chunk-2daba2ce":1,"chunk-2f6e9d50":1,"chunk-302c9c2a":1,"chunk-37e94ac7":1,"chunk-3aed29f0":1,"chunk-4864a9c6":1,"chunk-5322f370":1,"chunk-5ec75d54":1,"chunk-64090c9b":1,"chunk-64bc9d04":1,"chunk-264ea8e3":1,"chunk-580f2e46":1,"chunk-63987aca":1,"chunk-76bde2a4":1,"chunk-8aa503b8":1,"chunk-f730c4d0":1,"chunk-7163177a":1,"chunk-7ed3ff22":1,"chunk-859f39b0":1,"chunk-9f9481d0":1,"chunk-a87c9a62":1,"chunk-bd612336":1,"chunk-c70fde1c":1,"chunk-da49554a":1,"chunk-e26ed996":1,"chunk-f243ee4e":1,"chunk-f9e8fb12":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-069b5a0f":"74eafba2","chunk-0bed69fb":"31d6cfe0","chunk-0e3b4938":"b8a4874c","chunk-19814e2a":"31d6cfe0","chunk-1ab92bba":"f98f2937","chunk-225cb554":"0bdfa8d1","chunk-2f7cec82":"31d6cfe0","chunk-61bcfbda":"b7acf27a","chunk-7eeb79c0":"b3091214","chunk-85ef4af6":"2e1b0708","chunk-e2e632f4":"12010007","chunk-1b23f0d2":"6f355226","chunk-2d20f987":"31d6cfe0","chunk-2daba2ce":"b25d9462","chunk-2f6e9d50":"abf79b84","chunk-302c9c2a":"aabd98cd","chunk-37e94ac7":"b8a4874c","chunk-3aed29f0":"2370a93d","chunk-4864a9c6":"b0c80b6f","chunk-5322f370":"cb2bb2a9","chunk-5ec75d54":"7c3ce2a3","chunk-64090c9b":"4f881b92","chunk-64bc9d04":"f23cd7dd","chunk-264ea8e3":"dfbf2b4e","chunk-580f2e46":"45f8fe76","chunk-63987aca":"f31c146f","chunk-76bde2a4":"887ab502","chunk-8aa503b8":"10168845","chunk-f730c4d0":"81f7fe30","chunk-6aa192fa":"31d6cfe0","chunk-7163177a":"b8a4874c","chunk-7ed3ff22":"b8a4874c","chunk-859f39b0":"32fa781e","chunk-97705c9e":"31d6cfe0","chunk-9f9481d0":"998b4bec","chunk-a87c9a62":"f6e47170","chunk-bd612336":"b8a4874c","chunk-c70fde1c":"7532b89f","chunk-d21901a2":"31d6cfe0","chunk-da49554a":"78f326db","chunk-e26ed996":"5465d815","chunk-f243ee4e":"3be6f0e6","chunk-f9e8fb12":"521b9b2c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/platform/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
